import React, { Component } from 'react'
import { Carousel, Container } from 'react-bootstrap'
import DSCN2329 from '../jpgforpage/2017/DSCN2329.JPG'
import DSCN2327 from '../jpgforpage/2017/DSCN2327.JPG'
import DSCN2321 from '../jpgforpage/2017/DSCN2321.JPG'
import DSCN2323 from '../jpgforpage/2017/DSCN2323.JPG'
import DSCN2319 from '../jpgforpage/2017/DSCN2319.JPG'
import DSCN2317 from '../jpgforpage/2017/DSCN2317.JPG'
import DSCN2295 from '../jpgforpage/2017/DSCN2295.JPG'
import DSCN2284 from '../jpgforpage/2017/DSCN2284.JPG'
import DSCN2278 from '../jpgforpage/2017/DSCN2278.JPG'




export default class Photo2017 extends Component {
    render() {
        return (
            <Container>
                <Carousel>
                    <Carousel.Item>
                        <img 
                            src={DSCN2329} 
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2327}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2323} 
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2321} 
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2319}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2317}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2295}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2284}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN2278}
                            className='img-carousel-1'
                            alt="Photo2017"
                        />
                        <Carousel.Caption>
                            <p>Вручення дипломів 2017</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel> <hr />
            </Container>
           )
       }
   }
   
         